import React from 'react'
import { useWindowSize } from '@navent-jobs/ui-kit/hooks/window-size'
import { ContainerFluid, Col, Row } from '@navent-jobs/ui-kit/components/grid'
import { useTranslation } from 'react-i18next'
import { ButtonContent, CustomButton, CustomLink, ParagraphSimple } from './mixins'

interface CreateAlertaSuccessProps {
  closeHandler: () => void
  idFrecuencia: number
}

export const CreateAlertaSuccess = ({ idFrecuencia, closeHandler }: CreateAlertaSuccessProps) => {
  // Hooks
  const { t } = useTranslation()
  const { isMobile } = useWindowSize()

  return (
    <ContainerFluid>
      <Row>
        <Col>
          <ParagraphSimple mb32>
            <b>{idFrecuencia === 0 ? t('alertas.success.textEnvioInmediato') : t('alertas.success.textEnvioDiario')}</b>
          </ParagraphSimple>
        </Col>
      </Row>

      <Row>
        <Col>
          <ParagraphSimple>{t('alertas.success.textAjustes')}</ParagraphSimple>
        </Col>
      </Row>

      {/* Botones */}
      <Row>
        <Col>
          <ButtonContent>
            <CustomButton
              buttonoptions={{ variant: 'primary', size: 'medium', type: 'fill' }}
              onClick={closeHandler}
              order
            >
              {t('alertas.success.buttonListado')}
            </CustomButton>

            <CustomLink
              href="/postulantes/notificaciones-y-alertas#alertas"
              linkoptions={{
                variant: 'primary',
                size: 'medium',
                type: isMobile ? 'link' : 'outline',
                native: false,
              }}
            >
              {t('alertas.success.buttonAjustes')}
            </CustomLink>
          </ButtonContent>
        </Col>
      </Row>
    </ContainerFluid>
  )
}
